/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AgentBadge_agent$ref: FragmentReference;
declare export opaque type AgentBadge_agent$fragmentType: AgentBadge_agent$ref;
export type AgentBadge_agent = {|
  +name: string,
  +uuid: string,
  +version: ?string,
  +versionHasKnownIssues: boolean,
  +clusterQueue: ?{|
    +id: string,
    +uuid: string,
    +cluster: ?{|
      +uuid: string
    |},
  |},
  +organization: ?{|
    +slug: string
  |},
  +$refType: AgentBadge_agent$ref,
|};
export type AgentBadge_agent$data = AgentBadge_agent;
export type AgentBadge_agent$key = {
  +$data?: AgentBadge_agent$data,
  +$fragmentRefs: AgentBadge_agent$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentBadge_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionHasKnownIssues",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "kind": "LinkedField",
      "name": "clusterQueue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Cluster",
          "kind": "LinkedField",
          "name": "cluster",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agent",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'edac9e00d8ff958efa9ff8b94bf03696';

module.exports = node;
